import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

var _div, _LoadingOutlined, _SearchOutlined;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState, useEffect, useCallback, useContext } from 'react';
import { AutoComplete } from 'antd';
import PlacesAutocomplete from 'react-places-autocomplete';
import { SearchOutlined, LoadingOutlined } from '@ant-design/icons';
import { get } from 'lodash-es';
import Input from './Input';
import { SearchResultItem, SearchResultMain, SearchResultSecondary, SearchResultLabel } from './AutoCompleteHelperComponents';
import { TmsUIContext } from '../TmsUIProvider';
import translations from './translations';

var LocationSearchInput = function LocationSearchInput(_ref) {
  var value = _ref.value,
      initialKeyword = _ref.keyword,
      renderLocationOptions = _ref.renderLocationOptions,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
      _ref$enableFreeText = _ref.enableFreeText,
      enableFreeText = _ref$enableFreeText === void 0 ? false : _ref$enableFreeText,
      _ref$useCompleteEvent = _ref.useCompleteEventData,
      useCompleteEventData = _ref$useCompleteEvent === void 0 ? false : _ref$useCompleteEvent,
      _ref$additionalOption = _ref.additionalOptions,
      additionalOptions = _ref$additionalOption === void 0 ? [] : _ref$additionalOption,
      _ref$footerOptions = _ref.footerOptions,
      footerOptions = _ref$footerOptions === void 0 ? [] : _ref$footerOptions,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function (e) {
    return e;
  } : _ref$onChange,
      _ref$onSearch = _ref.onSearch,
      onSearch = _ref$onSearch === void 0 ? function (e) {
    return e;
  } : _ref$onSearch,
      _ref$onActionClick = _ref.onActionClick,
      onActionClick = _ref$onActionClick === void 0 ? function (e) {
    return e;
  } : _ref$onActionClick,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$asyncInitDelay = _ref.asyncInitDelay,
      asyncInitDelay = _ref$asyncInitDelay === void 0 ? 0 : _ref$asyncInitDelay,
      _ref$searchOptions = _ref.searchOptions,
      searchOptions = _ref$searchOptions === void 0 ? {} : _ref$searchOptions,
      _ref$searchResultLabe = _ref.searchResultLabel,
      searchResultLabel = _ref$searchResultLabe === void 0 ? 'search_results' : _ref$searchResultLabe,
      _ref$gmapsApiKey = _ref.gmapsApiKey,
      gmapsApiKey = _ref$gmapsApiKey === void 0 ? process.env.REACT_APP_GMAPS_API_KEY : _ref$gmapsApiKey;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      keyword = _useState2[0],
      setKeyword = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      scriptLoaded = _useState4[0],
      setScriptLoaded = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      localValue = _useState6[0],
      setLocalValue = _useState6[1];

  var _useContext = useContext(TmsUIContext),
      translate = _useContext.translate,
      setDefaultTranslations = _useContext.setDefaultTranslations;

  var handleSelect = function handleSelect(option, typeProps) {
    if (get(option, 'data.isFooterOption')) {
      onActionClick(option);
      return;
    }

    if (option) {
      // @ts-ignore
      typeProps(option).onClick();
    }

    if (value === undefined) {
      // @ts-ignore
      setLocalValue(option ? option.value : '');
    } // @ts-ignore


    var changedValue = useCompleteEventData ? option : option.value;
    onChange(changedValue, option);
  };

  var appendGScript = useCallback(function () {
    var scriptId = 'google-maps-script';
    var scriptElement = document.getElementById(scriptId);
    var placesLibExist = get(window, 'google.maps.places');

    if (placesLibExist) {
      setScriptLoaded(true);
    } else if (scriptElement) {
      var currentOnloadCallback = scriptElement.onload;

      scriptElement.onload = function () {
        if (currentOnloadCallback) {
          // @ts-ignore
          currentOnloadCallback();
        }

        setScriptLoaded(true);
      };
    } else if (!scriptElement) {
      var script = document.createElement('script');
      script.id = scriptId; // eslint-disable-next-line max-len

      script.src = "https://maps.googleapis.com/maps/api/js?key=".concat(gmapsApiKey, "&libraries=places");
      script.async = true;

      script.onload = function () {
        setScriptLoaded(true);
      };

      document.body.appendChild(script);
    }
  }, [gmapsApiKey]);
  useEffect(function () {
    if (asyncInitDelay) {
      setTimeout(function () {
        appendGScript();
      }, asyncInitDelay);
    } else {
      appendGScript();
    }
  }, [appendGScript, asyncInitDelay]);
  useEffect(function () {
    setKeyword(localValue);
  }, [localValue]);
  useEffect(function () {
    onSearch(keyword); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyword]);
  useEffect(function () {
    if (value !== undefined) {
      setLocalValue(value);
    }
  }, [value, setLocalValue]);
  useEffect(function () {
    if (initialKeyword !== undefined) {
      setLocalValue(initialKeyword);
    }
  }, [initialKeyword, setLocalValue]);
  useEffect(function () {
    setDefaultTranslations(translations);
  }, [setDefaultTranslations]);
  return scriptLoaded && /*#__PURE__*/React.createElement(PlacesAutocomplete, {
    onChange: function onChange(newKeyword) {
      return setKeyword(newKeyword || '');
    },
    searchOptions: _objectSpread({
      componentRestrictions: {
        country: ['id']
      }
    }, searchOptions),
    value: keyword
  }, function (_ref2) {
    var getInputProps = _ref2.getInputProps,
        suggestions = _ref2.suggestions,
        typeProps = _ref2.getSuggestionItemProps,
        locationSearchLoading = _ref2.loading;
    var locationSearchResults = suggestions.map(function (suggestion) {
      return {
        value: suggestion.description,
        label: renderLocationOptions ? renderLocationOptions(suggestion) : /*#__PURE__*/React.createElement(SearchResultItem, null, /*#__PURE__*/React.createElement(SearchResultMain, null, suggestion.formattedSuggestion.mainText), /*#__PURE__*/React.createElement(SearchResultSecondary, null, suggestion.formattedSuggestion.secondaryText)),
        data: suggestion
      };
    });
    return /*#__PURE__*/React.createElement(AutoComplete, {
      disabled: disabled,
      onBlur: function onBlur() {
        if (!enableFreeText) {
          setKeyword(localValue);
        }
      } // @ts-ignore
      ,
      onSelect: function onSelect(_, option) {
        return handleSelect(option, typeProps);
      } // @ts-ignore
      ,
      options: additionalOptions.length > 0 ? [].concat(_toConsumableArray(additionalOptions.map(function (opt) {
        return opt.options.length > 0 && {
          label: /*#__PURE__*/React.createElement(SearchResultLabel, null, // @ts-ignore
          opt.label),
          // @ts-ignore
          options: opt.options
        };
      })), [suggestions.length > 0 && {
        label: /*#__PURE__*/React.createElement(SearchResultLabel, null, translate("common:".concat(searchResultLabel))),
        options: locationSearchResults
      }, footerOptions.length > 0 && {
        label: _div || (_div = /*#__PURE__*/React.createElement("div", null)),
        options: footerOptions.map(function (opt) {
          return _objectSpread(_objectSpread({}, opt), {}, {
            data: {
              isFooterOption: true
            }
          });
        })
      }]).filter(Boolean) : locationSearchResults // @ts-ignore
      ,
      value: keyword
    }, /*#__PURE__*/React.createElement(Input, {
      allowClear: true,
      autoComplete: "one-time-code",
      onChange: function onChange(event) {
        getInputProps().onChange(event);

        if (!event.target.value) {
          setLocalValue('');
          handleSelect(null, typeProps);
        }
      },
      placeholder: placeholder,
      suffix: locationSearchLoading || loading ? _LoadingOutlined || (_LoadingOutlined = /*#__PURE__*/React.createElement(LoadingOutlined, null)) : _SearchOutlined || (_SearchOutlined = /*#__PURE__*/React.createElement(SearchOutlined, null))
    }));
  });
};

export default LocationSearchInput;